import React, { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Link,
  Tooltip,
  HStack,
  Heading,
} from "@chakra-ui/react";
import { DownloadIcon, ArrowUpIcon } from "@chakra-ui/icons";
import {
  fetchTableMetadata,
  fetchFilteredTables,
} from "../service/fileService";
interface FileUploadSectionProps {
  onShowCreateTable?: () => void;
  onShowFileUpload?: (tableName: string) => void;
}

const FileUploadSection: React.FC<FileUploadSectionProps> = ({
  onShowCreateTable,
  onShowFileUpload,
}) => {
  const [filteredTables, setFilteredTables] = useState<string[]>([]);
  useEffect(() => {
    const loadTables = async () => {
      try {
        const result = await fetchFilteredTables();
        if (result.statusCode == 0) {
          alert("No Record found");
        } else {
          setFilteredTables(result.data.map((t: any) => t.tableName));
        }
      } catch (err) {
        console.error("Error loading tables:", err);
      }
    };

    loadTables();
  }, []);
  const handleDownload = async (tableName: string) => {
    try {
      const result = await fetchTableMetadata(tableName);
      if (result.statusCode == 0) {
        alert("Table not available");
        throw new Error("Invalid API response");
      }

      const columnNames = result.data.map(
        (col: { columN_NAME: string }) => col.columN_NAME
      );

      const csvContent = columnNames.join(",") + "\n";

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${tableName}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <Box p={6} maxW="800px" mx="auto">
      <Heading size="sm" mb={2}>
        Upload data by data set
      </Heading>
      <Table variant="simple" size="md">
        <Thead>
          <Tr>
            <Th>Table</Th>
            <Th>Action</Th>
          </Tr>
        </Thead>
        <Tbody>
          {filteredTables.map((tableName) => (
            <Tr key={tableName}>
              <Td>
                <Link
                  color="teal.500"
                  onClick={() => handleDownload(tableName)}
                  display="flex"
                  alignItems="center"
                  gap={2}
                  cursor="pointer"
                >
                  <DownloadIcon />
                  {tableName}
                </Link>
              </Td>
              <Td>
                <HStack spacing={2}>
                  <Tooltip label="Upload File" hasArrow>
                    <IconButton
                      icon={<ArrowUpIcon />}
                      aria-label="Upload"
                      size="sm"
                      colorScheme="blue"
                      onClick={() =>
                        onShowFileUpload && onShowFileUpload(tableName)
                      }
                    />
                  </Tooltip>
                </HStack>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
      {onShowCreateTable && (
        <Box mt={4} textAlign="center">
          <Link
            color="blue.500"
            fontWeight="bold"
            cursor="pointer"
            onClick={onShowCreateTable}
          >
            + Create new table from file
          </Link>
        </Box>
      )}
    </Box>
  );
};

export default FileUploadSection;
